<template>
    <router-link
        class="room__list_grid_item"
        :to="{ name: 'ebs-room-show', params: { venueId: venueId, roomId: roomId } }"
    >
        <div class="columns">
            <div class="column is-narrow">
                <div class="room__list_grid_item_image">
                    <template v-if="thumbnailUrl">
                        <component-image
                            :url="thumbnailUrl"
                            :alt="roomName"
                            :full-height="true"
                        ></component-image>
                    </template>
                    <template v-else>
                        <v-icon name="image"/>
                    </template>
                </div>
            </div>
            <div class="column">
                <div class="room__list_grid_item_content">
                    <h2 class="room__list_grid_item_content_title">{{roomName}}</h2>
                    <div class="room__list_grid_item_content_details">
                        <div class="room__list_grid_item_content_details_capacity">
                            <div class="columns is-vcentered is-variable is-2">
                                <div class="column is-narrow">
                                    <v-icon name="users"/>
                                </div>
                                <div class="column">
                                    Capacity: {{roomCapacity}} people
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="room__list_grid_item_content_status">
                        <component-status :status="roomStatus"/>
                    </div>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
import api from '@/api'
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentImage from '@/components/default/shared/ComponentImage'

export default {
  components: { ComponentImage, ComponentStatus },
  name: 'room-list-grid-item',
  props: {
    item: {
      type: Object,
      required: true
    },
    venueId: {
      type: String,
      default: '',
      required: true
    }
  },
  computed: {
    thumbnailUrl: function () {
      if (this.item.files.length) {
        return `${api.files}/file/${this.item.files[0].fileId}`
      }
      return false
    },
    roomId: function () {
      return this.item.id
    },
    roomName: function () {
      return this.item.name
    },
    roomCapacity: function () {
      return this.item.capacity
    },
    roomStatus: function () {
      return this.item.status
    }
  }
}
</script>

<style lang="scss">
    @import '~@/assets/scss/components/ebs/rooms/roomlistgriditem';
</style>
